const CollectionName = "business";
let unsubscribeBusiness;
let unsubscribeLoyaltyRules;
let unsubscibeLoyaltyRules = {};

export async function setItemAvailable(businessId, itemTitle, isAvailable) {
    return await db.updateDocument(
        CollectionName,
        businessId,
        {
            unavailableItems: {
                [itemTitle]: !isAvailable,
            },
        });
}



export async function closeBusiness(code) {
    return await db.updateDocument(
        CollectionName,
        code,
        {
            open: false,
            notifications: {}, //we remove all users from getting notifications when the business closes
        });
}


export async function updateLoyaltyRule(code, id, item) {
    if (!id) throw new Error('Rule id is undefined');
    return await db.updateDocument(
        `${CollectionName}/${code}/loyaltyRules`,
        id,
        item);
}



export async function deleteLoyaltyRule(code, item) {

    return await db.deleteDocument(
        `${CollectionName}/${code}/loyaltyRules`,
        item.id);
}



export async function addNewLoyaltyRule(code, rule) {
    const path = `${CollectionName}/${code}/loyaltyRules`;
    const id = await db.addDocument(path, {})
    await db.updateDocument(path, id, rule);
}

function getItemNameFromMenu(itemId, menu) {
    for (let section of menu) {
        let item = section.items?.filter(x => x.id == itemId);
        if (item.length > 0) return item[0].name;
    }
}

export function getCoverImgUrl(code) {
    return `https://firebasestorage.googleapis.com/v0/b/pickapp-7bfc3.appspot.com/o/covers%2F${code}.jpg?alt=media`;
}

export async function listenToLoyaltyRule(businessId, ruleId, cb) {
    const path = `${CollectionName}/${businessId}/loyaltyRules`;

    if (unsubscibeLoyaltyRules[ruleId])
        await db.removeListener(unsubscibeLoyaltyRules[ruleId])

    unsubscibeLoyaltyRules[ruleId] = await db.listenToDocument(path, ruleId, cb)
}

export async function toggleNotification(businessCode, onOff, token, currentNotifications) {
    currentNotifications[token] = onOff;
    await db.updateDocument(
        CollectionName,
        businessCode,
        {
            notifications:
                currentNotifications
        }
    );
}

//TODO: add await
export async function setOutOfStock(businessCode, list) {
    await db.updateDocument(
        CollectionName,
        businessCode,
        {
            outOfStock: list,
        });
}

//TODO: add await
export async function setBusinessHours(businessCode, schedule) {
    await db.updateDocument(
        CollectionName,
        businessCode,
        {
            schedule,
        });
}

export async function setDeliverySettings(businessCode, settings) {
    await db.updateDocument(
        CollectionName,
        businessCode,
        {
            deliverySettings: settings
        });
}


export async function openBusiness(code) {
    await db.updateDocument(
        CollectionName,
        code,
        {
            open: true
        });
}


export async function saveMenu(businessCode, menuObj) {
    await db.updateDocument(
        CollectionName,
        businessCode,
        {
            menu: JSON.stringify(menuObj),
        });
}

export async function listenToLoyaltyRules(code, cb) {
    if (unsubscribeLoyaltyRules) await db.removeListener(unsubscribeLoyaltyRules)

    unsubscribeLoyaltyRules = await db.listenToCollection(`${CollectionName}/${code}/loyaltyRules`, [], cb)
}

export async function listenToBusiness(code, cb) {
    if (unsubscribeBusiness)
        await db.removeListener(unsubscribeBusiness)

    unsubscribeBusiness = await db.listenToDocument(CollectionName, code, cb)
}